<template>
    <div class="brands-filter-line">
        <button @click.prevent="closeMobileFilter()" type="button"
            class="btn btn-outline-danger btn-sm btn-offcanvas-close" data-dismiss="offcanvas"
            data-target="#product-filter" aria-label="Close">
            <ClientOnly><i class="fa-solid fa-xmark fa-2x"></i></ClientOnly>
        </button>
        <div class="category-list mb-5" v-if="!dontShowActiveFilters && brands.length > 0">
            <h4 class="mb-3">{{ $t("brands") }}</h4>
            <ul class="list-unstyled mb-0">
                <li v-for="categoryItem in brands" :key="categoryItem.id">
                    <b-link :to="`/` + categoryItem.url_path" style="text-decoration: underline;">{{
                        categoryItem.name
                        }}</b-link>
                </li>
            </ul>
        </div>
        <div class="selected-filter border-bottom pb-5 mb-5" v-if="isPriceFilterActive || filterItemsSelected.length">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h5 class="mb-0">{{ $t("used_filters") }}:</h5>
                <button type="button" class="btn-close" aria-label="Close" @click="removeAllActiveFilter"></button>
            </div>
            <ul class="list-unstyled mb-0">
                <li v-if="isPriceFilterActive">
                    <ClientOnly>
                        <button type="button" class="btn-close fs-6" aria-label="Close"
                            @click="removePriceFilter"></button>
                    </ClientOnly>
                    <span>
                        {{ `${priceFilterLabel ? priceFilterLabel : "Prijs"}` }}:
                        {{ priceFilter[0] + " - " + priceFilter[1] }}
                    </span>
                </li>
                <li v-for="(activeFilterItem, index) of filterItemsSelected" :key="index">
                    <ClientOnly>
                        <button type="button" class="btn-close fs-6" aria-label="Close"
                            @click="removeSelectedItem(activeFilterItem.value)"></button>
                    </ClientOnly>
                    <span>
                        {{ activeFilterItem.type_label }}:
                        {{ activeFilterItem.label }}
                    </span>
                </li>
            </ul>
        </div>
        <div v-for="prodFilter of productFilters" :key="prodFilter.attribute_code">
            <div v-if="prodFilter.attribute_code == 'price'">
                <div class="cat-filter border-bottom pb-5 mb-5">
                    <h5 class="mb-3">{{ prodFilter.label }}</h5>
                    <div class="row">
                        <div class="col">
                            <input type="text" class="form-control text-center" id="product-price-range-min"
                                placeholder="Minimumprijs" aria-label="Minimumprijs" :value="`${priceFilter[0]}`"
                                ref="priceSliderMinVal" @change="handlePriceSliderValChange">
                        </div>
                        <div class="col-auto align-self-center">
                            -
                        </div>
                        <div class="col">
                            <input type="text" class="form-control text-center" id="product-price-range-max"
                                placeholder="Maximale prijs" aria-label="Maximale prijs" :value="`${priceFilter[1]}`"
                                ref="priceSliderMaxVal" @change="handlePriceSliderValChange">
                        </div>
                    </div>
                    <div class="filter-price-range mx-2 my-5" id="product-price-range"></div>
                </div>
            </div>
            <div v-if="
                prodFilter.attribute_code != 'size' &&
                prodFilter.attribute_code != 'price' &&
                prodFilter.attribute_code != 'category_uid'
            ">
                <div class="cat-filter border-bottom pb-5 mb-5">
                    <h5 class="mb-3">{{ prodFilter.label }}</h5>
                    <ul class="list-unstyled mb-0">
                        <li v-for="(brandsFilterItem, index) in prodFilter.options" :key="index">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" :key="brandsFilterItem.value"
                                    :name="brandsFilterItem.label" :id="brandsFilterItem.value"
                                    :ref="brandsFilterItem.value" :value="brandsFilterItem.value" @click="
                                        onChangeFilter($event, {
                                            attribute_code: prodFilter.attribute_code,
                                            type_label: prodFilter.label,
                                            value: brandsFilterItem.value,
                                            label: brandsFilterItem.label,
                                        })
                                        " />
                                <label class="form-check-label" :for="brandsFilterItem.value">
                                    {{ brandsFilterItem.label }}
                                </label>
                            </div>
                            <span class="text-muted">({{ brandsFilterItem.count }})</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="prodFilter.attribute_code == 'size'">
                <div class="cat-filter border-bottom pb-5 mb-5">
                    <h5 class="mb-3">{{ $t("choose_size") }}</h5>
                    <ul class="list-unstyled mb-0">
                        <li v-for="(sizeFilterItem, index) in prodFilter.options" :key="index">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" :id="sizeFilterItem.value"
                                    :key="sizeFilterItem.value" :name="sizeFilterItem.label" :ref="sizeFilterItem.value"
                                    :value="sizeFilterItem.value" @change="
                                        onChangeFilter($event, {
                                            attribute_code: prodFilter.attribute_code,
                                            type_label: prodFilter.label,
                                            value: sizeFilterItem.value,
                                            label: sizeFilterItem.label,
                                        })
                                        " />
                                <label class="form-check-label" :for="sizeFilterItem.name">
                                    {{ sizeFilterItem.label }}
                                </label>
                            </div>
                            <span class="text-muted">({{ sizeFilterItem.count }})</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Logger } from "@storefront/core/lib/logger";
import ClientOnly from "vue-client-only";
import { mapActions } from "vuex";
import { isMobile } from "mobile-device-detect";
import { mapGetters } from "vuex";
/*import VueRangeSlider from "vue-slider-component/dist-css/vue-slider-component.umd.min.js";*/
import "vue-slider-component/dist-css/vue-slider-component.css";
import noUiSlider from 'nouislider/dist/nouislider.min.js';
import "nouislider/dist/nouislider.min.css";
export default {
    name: "ProductFilterSidebar",
    components: {
        ClientOnly,
        /*VueRangeSlider,*/
    },
    props: {
        dontShowActiveFilters: {
            type: Boolean,
        },
    },

    created() {
        this.min = 0;
        this.max = 250;
        this.enableCross = false;
        this.formatter = "€ {value}";
        this.tooltipDir = "bottom";
    },
    methods: {
        ...mapActions({
            changeMobileCategoryFilterShow:
                "mobileRes/changeMobileCategoryFilterShow",
        }),
        onChangeFilter(event, filter) {
            if (typeof filter != "undefined" && typeof filter.value != "undefined") {
                if (event.target.checked == true) {
                    this.$store.commit("product/setActiveFilter", filter);
                } else {
                    this.$store.commit("product/removeActiveFilter", filter);
                }
                this.updateUrlFilters();
            }
        },
        removeAllActiveFilter() {

            this.filterItemsSelected.forEach((filters) => {
                if (this.$refs[filters.value] && this.$refs[filters.value][0]) {
                    this.$refs[filters.value][0].checked = false;
                }
            });
            this.$store.commit("product/removeAllActiveFilter");
            let priceRangeEle = document.getElementById('product-price-range');
            priceRangeEle.noUiSlider.setHandle(0, this.priceFilterMin);
            priceRangeEle.noUiSlider.setHandle(1, this.priceFilterMax);
            this.updateUrlAllFilters();
        },
        removePriceFilter() {
            let priceRangeEle = document.getElementById('product-price-range');
            priceRangeEle.noUiSlider.setHandle(0, this.priceFilterMin);
            priceRangeEle.noUiSlider.setHandle(1, this.priceFilterMax);

            const priceFilter = [this.priceFilterMin, this.priceFilterMax];
            this.$store.commit("product/setPriceFilter", priceFilter);

            const path = "/" + this.category.url_path;
            const query = { ...this.$route.query };
            delete query["filter-price"];
            delete query["page"];

            this.$router.replace({ path, query });
        },
        removeSelectedItem(id) {
            const filter = { value: id };
            if (this.$refs[id] && this.$refs[id][0]) {
                this.$refs[id][0].checked = false;
            }
            this.$store.commit("product/removeActiveFilter", filter);
            this.updateUrlFilters();
        },
        toggleFilter(event) {
            this.$emit("clicked", event);
        },
        updateUrlFilters() {
            const activeFilters = {};
            this.filterItemsSelected.forEach((val) => {
                if (activeFilters[val.attribute_code]) {
                    activeFilters[val.attribute_code].push(val.value);
                } else {
                    activeFilters[val.attribute_code] = [val.value];
                }
            });

            const path = "/" + this.category.url_path;
            const query = { ...this.$route.query };

            for (const q in query) {
                if (q.startsWith("filter-") && q !== "filter-price") {
                    delete query[q];
                }
            }
            for (const attr in activeFilters) {
                query[`filter-${attr}`] = activeFilters[attr].toString();
            }
            delete query["page"];

            this.$router.replace({ path, query });
        },
        updateUrlAllFilters() {
            const activeFilters = {};
            this.filterItemsSelected.forEach((val) => {
                if (activeFilters[val.attribute_code]) {
                    activeFilters[val.attribute_code].push(val.value);
                } else {
                    activeFilters[val.attribute_code] = [val.value];
                }
            });

            const path = "/" + this.category.url_path;
            const query = { ...this.$route.query };

            for (const q in query) {
                if (q.startsWith("filter-")) {
                    delete query[q];
                }
            }
            for (const attr in activeFilters) {
                query[`filter-${attr}`] = activeFilters[attr].toString();
            }
            delete query["page"];

            this.$router.replace({ path, query });
        },
        init_price_range_slider() {
            let priceRangeEle = document.getElementById('product-price-range'),
                priceRangeMinEle = document.getElementById('product-price-range-min'),
                priceRangeMaxEle = document.getElementById('product-price-range-max'),
                priceRangeInputs = [priceRangeMinEle, priceRangeMaxEle];
            noUiSlider.create(priceRangeEle, {
                start: [this.priceFilterMin, this.priceFilterMax],
                step: 1,
                handleAttributes: [
                    { 'aria-label': 'Minimumprijs' },
                    { 'aria-label': 'Maximale prijs' },
                ],
                range: {
                    'min': this.priceFilterMin,
                    'max': this.priceFilterMax
                },
                pips: {
                    mode: 'count',
                    values: 5,
                    density: 20
                },
                format: {
                    to: function (value) {
                        return value;
                    },
                    // 'from' the formatted value.
                    // Receives a string, should return a number.
                    from: function (value) {
                        return Number(value);
                    }
                }
            });
            priceRangeEle.noUiSlider.on('end', function (values, handle) {
                priceRangeInputs[handle].value = parseInt(values[handle]);
                this.priceFilter = values;
            }.bind(this));
            priceRangeInputs.forEach(function (input, handle) {
                input.addEventListener('change', function () {
                    priceRangeEle.noUiSlider.setHandle(handle, this.value);
                });
            });
        },
        handlePriceSliderValChange() {
            const priceSliderMinVal = this.$refs.priceSliderMinVal[0].value;
            const priceSliderMaxVal = this.$refs.priceSliderMaxVal[0].value;
            const updatedpriceFilter = [];
            updatedpriceFilter[0] = parseInt(priceSliderMinVal);
            updatedpriceFilter[1] = parseInt(priceSliderMaxVal);
            this.priceFilter = updatedpriceFilter;
        },
        closeMobileFilter() {
            const productFilterAside = document.getElementById('product-filter');
            if (productFilterAside && productFilterAside.classList) {
                productFilterAside.classList.remove("show");
            }
        }
    },
    data() {
        return {
            value: [0, 200],
            sliderIsLoaded: false,
            bla: false,
            minAngle: 10,
            maxAngle: 30,
            filterExpanded: false,
        };
    },
    computed: {
        ...mapGetters({
            getMobileCategoryFilterShow: "mobileRes/getMobileCategoryFilterShow",
        }),
        isPriceFilterActive() {
            return this.$store.getters["product/getIsPriceFilterActive"];
        },
        isMobleScreen() {
            return isMobile;
        },
        filterItemsSelected() {
            return this.$store.getters["product/getActiveFilter"];
        },
        product() {
            return this.$store.getters["product/getCurrentProduct"];
        },
        priceFilterLabel() {
            if (this.productFilters) {
                const priceFilter = this.productFilters.find(
                    (filter) => filter.attribute_code == "price"
                );
                return priceFilter && priceFilter.label;
            }
            return null;
        },
        priceFilter: {
            get: function () {
                return this.$store.getters["product/getPriceFilter"];
            },
            set: function (val) {
                Logger.debug("set", "setPriceFilter", val)();
                this.$store.commit("product/setPriceFilter", val);

                const path = "/" + this.category.url_path;
                const query = { ...this.$route.query };
                if (this.isPriceFilterActive) {
                    query["filter-price"] = `${val[0]}-${val[1]}`;
                } else {
                    delete query["filter-price"];
                }
                delete query["page"];

                this.$router.replace({ path, query });
            },
        },
        priceFilterMin() {
            return this.$store.getters["product/getPriceFilterMin"];
        },
        priceFilterMax() {
            return this.$store.getters["product/getPriceFilterMax"];
        },
        productFilters: {
            get: function () {
                return this.$store.getters["product/getProductFilters"];
            },
            set: function (val) {
                Logger.debug("set", "productFilters", val)();
                //this.$store.commit("category/setProductFilters", val);
            },
        },
        brands() {
            return this.$store.getters["product/getBrandSlider"];
        },
    },
    updated() {
        if (this.filterItemsSelected && this.filterItemsSelected.length) {
            this.filterItemsSelected.forEach((filter) => {
                if (this.$refs[filter.value] && this.$refs[filter.value][0]) {
                    this.$refs[filter.value][0].checked = true;
                }
            });
        }
    },
    watch: {
        $route(to, from) {
            if (to.path !== from.path) {
                let attempts = 0;
                let maxAttempts = 10;
                let intervalTime = 1000;
                const interval = setInterval(() => {
                    if (typeof document !== 'undefined') {
                        let priceRangeEle = document.getElementById('product-price-range');
                        if (priceRangeEle) {
                            this.init_price_range_slider();
                            clearInterval(interval);
                        } else if (attempts >= maxAttempts) {
                            clearInterval(interval);
                        }
                        attempts++;
                    } else {
                        clearInterval(interval);
                    }
                }, intervalTime);
            }
        }
    },
    mounted() {
        let attempts = 0;
        let maxAttempts = 10;
        let intervalTime = 1000;
        const interval = setInterval(() => {
            let priceRangeEle = document.getElementById('product-price-range');
            if (priceRangeEle) {
                this.init_price_range_slider();
                clearInterval(interval);
            } else if (attempts >= maxAttempts) {
                clearInterval(interval);
            }
            attempts++;
        }, intervalTime);
    },
};
</script>

<style lang="scss">
</style>